import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import img1 from "../assest/user3.png";
import img2 from "../assest/user3.png";
import img3 from "../assest/user3.png";
// import img4 from "../assest/user3.png";

import "./mainpage.css";

function MainPage() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();   

  const [activeTab, setActiveTab] = useState("collector");

  useEffect(() => {
    const mountWidget = () => {
      if (window.RAG_WIDGET?.init && !document.getElementById("rag-widget-root")) {
        window.RAG_WIDGET.init({ containerId: "rag-widget-mount" });
      }
    };

    mountWidget();
    const retry = setTimeout(mountWidget, 300);

    return () => {
      clearTimeout(retry);
      document.getElementById("rag-widget-root")?.remove();
      document.getElementById("rag-widget-styles")?.remove();
    };
  }, []);

  return (
    <div className="collector-login-page">
      <div id="rag-widget-mount"></div>

      <div className="collector-left">
        <div className="collector-header">
          <div className="minister-section">
               <div className="ministerrow">
        <img src={img1} alt="Chief Minister" />
        <h4>{t("chiefMinisterName")}</h4>
        <p>{t("chiefMinister")}</p>
      </div>

            <div className="minister-row">
               <div className="minister">
          <img src={img2} alt="Deputy Minister" />
          <h4>{t("deputyCMName1")}</h4>
          <p>{t("deputyCM")}</p>
        </div>

                  <div className="minister">
          <img src={img3} alt="Deputy Minister" />
          <h4>{t("deputyCMName2")}</h4>
          <p>{t("deputyCM2")}</p>
        </div>
            </div>
          </div>
        </div>

        {/* <div className="collector-info">
          <div className="officer">
            <img src={img4} alt="Collector" />
            <p>{t("collector")}</p>
          </div>

          <div className="officer">
            <img src={img4} alt="SP" />
            <p>{t("sp")}</p>
          </div>
        </div> */}

        <div className="collector-title">
          <h2>{t("title")}</h2>
        </div>
      </div>

      <div className="collector-right">

   
        <div className="language-selector">
          <select
            value={i18n.language}
            onChange={(e) => {
              const newLang = e.target.value;
              i18n.changeLanguage(newLang);
              // localStorage.setItem("i18nextLng", newLang);
              
              window.dispatchEvent(
                new CustomEvent("languageChanged", { detail: newLang })
              );
            }}
          >
            <option value="en">English</option>
            <option value="hi">Hindi</option>
          
          </select>
        </div>

        <div className="login-card">
          <div className="login-tabs-column">

            <button
              type="button"
              className={activeTab === "collector" ? "tab-col active" : "tab-col"}
              onClick={() => {
                setActiveTab("collector");
                navigate("/collectorLoginPage");
              }}
            >
              {t("adminLogin")}
            </button>

            <button
              type="button"
              className={activeTab === "officer" ? "tab-col active" : "tab-col"}
              onClick={() => {
                setActiveTab("officer");
                window.location.href = "https://officer.aigram.texoriai.com/";
              }}
            >
              {t("officerLogin")}
            </button>

          </div>
        </div>
      </div>
    </div>
  );
}

export default MainPage;